import {Condition} from '@ucast/core';
import {guard} from '@ucast/mongo2js';
import {Rule, RuleSet} from '../search/query-builder.interfaces';

export type OperatorType = '$eq' | '$ne' | '$lt' | '$lte' | '$gt' | '$gte' | '$in' | '$nin' | '$regex';

export const OPERATORS: Record<string, OperatorType> = {
    Equlas: '$eq',
    'Not Equals': '$ne',
    'Less than': '$lt',
    'Less than equal': '$lte',
    'Greater than': '$gt',
    'Greater than equal': '$gte',
    In: '$in',
    'Not in': '$nin',
    Contains: '$regex',
};

const conditions: any = {and: '$and', or: '$or'};

export function withAnd(searchObj: Record<string, Rule>): Condition {
    const rules: Rule[] = Object.values(searchObj).filter(r => r.value !== null);
    const x: RuleSet = {
        condition: 'and',
        rules,
    };
    const ruleset = mapRuleSet(x);
    const test = guard(ruleset);

    return test.ast;
}

// getSchemaType = (field: any) => {
//   return model.schema.paths[field] ? model.schema.paths[field].instance : false;
// }

// Map each rule to a MongoDB query
export function mapRule(rule: Rule) {
    const field = rule.field;
    let value = rule.value;

    if (!value) value = null;

    const operator = OPERATORS[rule.operator] ? OPERATORS[rule.operator] : '$eq';

    // Create a MongoDB query
    let mongoDBQuery;

    // Check if operator is $regex
    if (operator === '$regex') {
        // Set case insensitive option
        mongoDBQuery = {
            [field]: {
                [operator]: value,
                $options: 'i',
            },
        };
    } else {
        mongoDBQuery = {[field]: {[operator]: value}};
    }

    return mongoDBQuery;
}

export function mapRuleSet(ruleSet: RuleSet): any {
    if (ruleSet.rules && ruleSet.rules.length < 1) {
        return;
    }
    const rulues = ruleSet.rules.map((rule: Rule | RuleSet) => {
        const x = rule as Rule;
        if (x.operator !== undefined) {
            return mapRule(rule as Rule);
        } else {
            return mapRuleSet(rule as RuleSet);
        }
    });

    return {
        [conditions[ruleSet.condition]]: rulues,
    };
}
